import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from "@mui/material";
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { useState } from "react";
import { handleErrors } from "common.js";
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from "axios";
import '../../../assets/style/style.css';
import configurations from "config";
import { RETURN_REQUEST } from "constants.js";
import { dateTimeFormat } from "common.js";
import { useTranslation } from "react-i18next";
import ReturnProductDispose from "./ReturnProductDispose";
import ReverseFulfillments from "./ReverseFulfillments";
import ReturnRequestRejectionPopup from "./ReturnRequestRejectionPopup";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import DoDisturbIcon from '@mui/icons-material/DoDisturb';

function ReturnSummary(props) {
  const { t }                          = useTranslation();
  const navigate                       = useNavigate();
  const baseUrl                        = configurations.baseUrl;
  const azureFunctionVendorFrontendKey = configurations.azureFunctionVendorFrontendKey;
  const bearerToken                    = `Bearer ${localStorage.getItem('JWTToken')}`;
  const returnID                       = props.returnID;
  const setIsLoading                     = props.setIsLoading;
  const [pageContent, setPageContent]               = useState(props.pageContent);
  const [rejectionPopupOpen, setRejectionPopupOpen] = useState(false);
  const [approveConfirmationDialogOpen, setApproveConfirmationDialogOpen] = useState(false);
  const [openReverseFulfillmentModel, setOpenReverseFulfillmentModel] = useState(false);
  const [openReturnProductDisposeModel, setOpenReturnProductDisposeModel] = useState(false);

  let returnRequestStatus = pageContent.status == RETURN_REQUEST.REQUESTED ? t('requested') :
                            pageContent.status == RETURN_REQUEST.OPEN ? t('open') :
                            pageContent.status == RETURN_REQUEST.DECLINED ? t('declined') :
                            pageContent.status == RETURN_REQUEST.CLOSED ? t('closed') : 
                            null;

  const handleReverseFulfillments = () => {
                                            setOpenReverseFulfillmentModel(true);
                                          }

  const handleReturnProductDispose = () => {
                                              setOpenReturnProductDisposeModel(true);
                                           }

  const handleReturnApprove = () => {
                                      setApproveConfirmationDialogOpen(false);
                                      setIsLoading(true);
                                      axios({    
                                        url     : baseUrl+"/return/approve",
                                        method  : "POST",
                                        data    : { id: returnID },
                                        headers : {
                                          Authorization   : bearerToken,
                                          function        : azureFunctionVendorFrontendKey
                                        },      
                                      }).then(function (response) 
                                      {
                                          setIsLoading(false);

                                          const responseData           = response.data;
                                          const responseDataStatusCode = response.data.status;
                                          const responseStatusCode     = response.status;
                                          
                                          if(responseStatusCode === 200)
                                          {
                                              if(responseDataStatusCode === 0)
                                              {
                                                toast.error(t(response.data.message));
                                                return;
                                              }
                                              else if(responseDataStatusCode === 1)
                                              {
                                                toast.success(t(response.data.message)); 
                                                setPageContent(responseData.data);
                                                
                                                return;                 
                                              }
                                          }    
                                          else 
                                          {
                                            toast.error(t('An unexpected error occurred while communicating with server'));
                                            return;            
                                          }    
                                      }).catch(function (error) {
                                        setIsLoading(false);
                                        handleErrors(error, t, navigate);
                                      });
                                  } 

  const handleApproveConfirmationDialogOpen = () => {
                                                      setApproveConfirmationDialogOpen(true);
                                                   };
                                                                            
  const handleApproveConfirmationDialogClose = () => {
                                                      setApproveConfirmationDialogOpen(false);
                                                    };

  const approveConfirmationModelLoad = () => {
                                        return (      
                                          <Dialog open={approveConfirmationDialogOpen} onClose={handleApproveConfirmationDialogClose}>
                                            <DialogTitle>{t("Confirm Return Approval")}</DialogTitle>
                                            <DialogContent>
                                              <DialogContentText>
                                                {t("Are you sure you want to approve this return request?")}            
                                              </DialogContentText>
                                            </DialogContent>
                                            <DialogActions>
                                              <Button onClick={handleApproveConfirmationDialogClose} color="primary">
                                                {t("cancel")}
                                              </Button>
                                              <Button onClick={handleReturnApprove} color="secondary">
                                                {t("Approve")}
                                              </Button>
                                            </DialogActions>
                                          </Dialog>
                                          );    
                                      }   

  return (
            <>
            <Grid container spacing={0} mt={1}>
              <Grid item sm={6} xs={12} my={1}>                       
                <Typography sx={{ fontSize: 14 }} component="div">
                  <Box className="orderStatusBox">
                    <div className="orderStatusBoxLeft">{t('Ordered On')}</div>
                    <div className="orderStatusBoxMiddle">:</div>
                    <div className="orderStatusBoxRight">
                      {dateTimeFormat(pageContent.orderedDate)}
                    </div>
                  </Box>  
                </Typography> 
              </Grid>
              <Grid item sm={6} xs={12} my={1}>
                <Typography sx={{ fontSize: 14 }} component="div">
                  <Box className="orderStatusBox">
                    <div className="orderStatusBoxLeft">{t('Returned On')}</div>
                    <div className="orderStatusBoxMiddle">:</div>
                    <div className="orderStatusBoxRight">
                      {dateTimeFormat(pageContent.createdAt)}
                    </div>
                  </Box>  
                </Typography>     
              </Grid>


              <Grid item sm={6} xs={12} my={1}>
                <Typography sx={{ fontSize: 14 }} component="div">
                  <Box className="orderStatusBox">
                    <div className="orderStatusBoxLeft">{t('Return Status')}</div>
                    <div className="orderStatusBoxMiddle">:</div>
                    <div className="orderStatusBoxRight orderStatusBoxAction">
                      {returnRequestStatus}
                    </div>
                  </Box>  
                </Typography> 
              </Grid>
              
              <Grid item sm={6} xs={12} my={1}>
                <Typography sx={{ fontSize: 14 }} component="div">
                  <Box className="orderStatusBox">
                    <div className="orderStatusBoxLeft">{t('Customer')}</div>
                    <div className="orderStatusBoxMiddle">:</div>
                    <div className="orderStatusBoxRight">
                      {pageContent.customerEmail}
                    </div>
                  </Box>  
                </Typography> 
              </Grid>

              {pageContent.wayBillNo ?                 
                <Grid item sm={6} xs={12} my={1}>
                  <Typography sx={{ fontSize: 14 }} component="div">
                    <Box className="orderStatusBox">
                      <div className="orderStatusBoxLeft">{t('WayBill No')}</div>
                      <div className="orderStatusBoxMiddle">:</div>
                      <div className="orderStatusBoxRight">
                        {pageContent.wayBillNo}
                      </div>
                    </Box>  
                  </Typography> 
                </Grid>
              : null}
              {pageContent.disposed === 1 ?                 
                <Grid item sm={6} xs={12} my={1}>
                  <Typography sx={{ fontSize: 14 }} component="div">
                    <Box className="orderStatusBox">
                      <div className="orderStatusBoxLeft">{t('Disposal Status')}</div>
                      <div className="orderStatusBoxMiddle">:</div>
                      <div className="orderStatusBoxRight">
                        {t("Disposed")}
                      </div>
                    </Box>  
                  </Typography> 
                </Grid>
              : null}
              {pageContent.returnReason ?         
                <Grid item xs={12} my={1}>                
                  <Typography sx={{ fontSize: 14 }} component="div">
                    <Box className="orderStatusBox">
                      <div className="orderStatusBoxLeft">{t('Return Reason')}</div>
                      <div className="orderStatusBoxMiddle">:</div>
                      <div className="orderStatusBoxRight">
                        {t("shoppify return reason "+pageContent.returnReason)}
                      </div>
                    </Box>  
                  </Typography>                        
                </Grid>              
              : null}
              {pageContent.customerNote ?         
                <Grid item xs={12} my={1}>                
                  <Typography sx={{ fontSize: 14 }} component="div">
                    <Box className="orderStatusBox">
                      <div className="orderStatusBoxLeft">{t('Customer Note')}</div>
                      <div className="orderStatusBoxMiddle">:</div>
                      <div className="orderStatusBoxRight">
                        {pageContent.customerNote}
                      </div>
                    </Box>  
                  </Typography>                        
                </Grid>              
              : null}         
              {pageContent.declineReason ?         
                <Grid item xs={12} my={1}>                
                  <Typography sx={{ fontSize: 14 }} component="div">
                    <Box className="orderStatusBox">
                      <div className="orderStatusBoxLeft">{t('Decline Reason')}</div>
                      <div className="orderStatusBoxMiddle">:</div>
                      <div className="orderStatusBoxRight">
                        {t("vendor decline reason "+pageContent.declineReason)}
                      </div>
                    </Box>  
                  </Typography>                        
                </Grid>              
              : null}       
              {pageContent.declineNote ?         
                <Grid item xs={12} my={1}>                
                  <Typography sx={{ fontSize: 14 }} component="div">
                    <Box className="orderStatusBox">
                      <div className="orderStatusBoxLeft">{t('Decline Note')}</div>
                      <div className="orderStatusBoxMiddle">:</div>
                      <div className="orderStatusBoxRight">
                        {pageContent.declineNote}
                      </div>
                    </Box>  
                  </Typography>                        
                </Grid>              
              : null} 

              {((pageContent.status === RETURN_REQUEST.REQUESTED || pageContent.status === RETURN_REQUEST.OPEN) &&(pageContent.disposed !=RETURN_REQUEST.DISPOSED))?         
                <Grid item xs={12} my={1}>                
                  <Typography sx={{ fontSize: 14 }} component="div">
                    <Box className="orderStatusBox">
                      <div className="orderStatusBoxLeft">{t('Action')}</div>
                      <div className="orderStatusBoxMiddle">:</div>
                      <div className="orderStatusBoxRight">
                        {pageContent.status === RETURN_REQUEST.REQUESTED ?
                          <Box sx={{ display: 'flex' }}>
                            <Box 
                                className="squareBoxApprove"                            
                                onClick={() => handleApproveConfirmationDialogOpen()}
                            >
                              <CheckCircleOutlineIcon color="success" fontSize="medium" titleAccess={t("Return Approve")} />
                            </Box>
                            {approveConfirmationDialogOpen ? approveConfirmationModelLoad() : <></>}

                            <Box 
                                className="squareBoxReject"
                                onClick={()=> {
                                                setRejectionPopupOpen(true);
                                              }
                                        }                           
                            >
                              <DoDisturbIcon color="error" fontSize="medium" titleAccess={t("Return Decline")} />
                            </Box>
                            {rejectionPopupOpen ?
                              <ReturnRequestRejectionPopup
                                returnID={returnID}
                                setPageContent = {setPageContent}
                                rejectionPopupOpen = {rejectionPopupOpen}                              
                                setRejectionPopupOpen = {setRejectionPopupOpen}
                              />
                              :
                            null}
                          </Box>
                          :
                          null
                        }

                        {pageContent.status === RETURN_REQUEST.OPEN ?
                          <>
                          {pageContent.shopifyReverseDeliveryStatus === 1 ?
                            <>
                              {pageContent.disposed === 0 ?
                                <Button                     
                                  variant="contained" 
                                  sx={{color : '#FFFFFF'}} 
                                  onClick={() => handleReturnProductDispose()}>
                                  {t("Dispose")}                    
                                </Button>
                              : null}
                            </>
                          :
                          <>
                            <Button                     
                              variant="contained" 
                              sx={{color : '#FFFFFF'}} 
                              onClick={() => handleReverseFulfillments()}>
                              {t("Reverse Fullfillments")}                    
                            </Button>                            
                          </>
                          }  
                          </>
                        : null}

                        {openReverseFulfillmentModel ? 
                          <ReverseFulfillments 
                            returnID={returnID} 
                            openReverseFulfillmentModel={openReverseFulfillmentModel}
                            setPageContent={setPageContent}                          
                            setOpenReverseFulfillmentModel={setOpenReverseFulfillmentModel}
                          /> 
                        : null}

                        {openReturnProductDisposeModel ? 
                          <ReturnProductDispose 
                            returnID={returnID} 
                            returnQuantity={pageContent.quantity}
                            openReturnProductDisposeModel={openReturnProductDisposeModel}
                            setPageContent={setPageContent}    
                            setOpenReturnProductDisposeModel={setOpenReturnProductDisposeModel}
                          /> 
                        : null}
                      </div>
                    </Box>  
                  </Typography>                        
                </Grid>              
              : null}   
            </Grid>            
          </>                       
        );
}
export default ReturnSummary;
